"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationStepOne = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const form_1 = require("../../molecules/form/form");
const person_preview_1 = require("../../molecules/person-preview");
const form_2 = require("../../atoms/form");
const buttons_1 = require("../../atoms/buttons");
var formKeys;
(function (formKeys) {
    formKeys["firstName"] = "firstName";
    formKeys["lastName"] = "lastName";
    formKeys["email"] = "email";
})(formKeys || (formKeys = {}));
const RegistrationStepOne = ({ onSubmit, name, avatar, useForm }) => {
    var _a, _b, _c;
    const { t } = (0, react_i18next_1.useTranslation)(["md"]);
    const { register, handleSubmit, formState: { errors } } = useForm;
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.H1, { "data-cy": "registration-header", children: t("registrationStepOneForm.title") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("registrationStepOneForm.greetings") }, void 0), name && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("registrationStepOneForm.coach") }, void 0), (0, jsx_runtime_1.jsx)(person_preview_1.PersonPreview, { "name-data-cy": "coach-name", avatar: avatar || "", name: name }, void 0)] }, void 0)), (0, jsx_runtime_1.jsxs)(form_1.Form, { variant: "vertical", onSubmit: handleSubmit(onSubmit), children: [(0, jsx_runtime_1.jsx)("label", { children: t("registrationStepOneForm.firstName") }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { placeholder: t("registrationStepOneForm.firstName"), err: (_a = errors[formKeys.firstName]) === null || _a === void 0 ? void 0 : _a.message, "data-cy": "first-name-input", "error-data-cy": "first-name-input-error", ...register(formKeys.firstName, {
                            required: { value: true, message: t("errors.inputEmpty") }
                        }), name: formKeys.firstName }, void 0), (0, jsx_runtime_1.jsx)("label", { children: t("registrationStepOneForm.lastName") }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { err: (_b = errors[formKeys.lastName]) === null || _b === void 0 ? void 0 : _b.message, placeholder: t("registrationStepOneForm.lastName"), "data-cy": "last-name-input", "error-data-cy": "last-name-input-error", ...register(formKeys.lastName, {
                            required: { value: true, message: t("errors.inputEmpty") }
                        }), name: formKeys.lastName }, void 0), (0, jsx_runtime_1.jsx)("label", { children: t("registrationStepOneForm.email") }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { err: (_c = errors[formKeys.email]) === null || _c === void 0 ? void 0 : _c.message, placeholder: t("registrationStepOneForm.emailPlaceholder"), type: "email", "data-cy": "email-input", "error-data-cy": "email-input-error", ...register(formKeys.email, {
                            required: { value: true, message: t("errors.inputEmpty") }
                        }), name: formKeys.email }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { "data-cy": "register-1st-step-submit", variant: "primary", type: "submit", children: t("registrationStepOneForm.btnSubmit") }, void 0)] }, void 0)] }, void 0));
};
exports.RegistrationStepOne = RegistrationStepOne;
const Wrapper = styled_components_1.default.div `
  min-width: 296px;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.spacings.xl} 0 ${theme.spacings.xxl2} `};
  width: 50%;

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    width: 100%;
    padding: ${({ theme }) => `${theme.spacings.xxl} ${theme.spacings.xxl2}`};
  }

  h1 {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  & > p:first-of-type {
    color: ${({ theme }) => theme.colors.greyBase};
    line-height: 1.5rem;
    margin-bottom: ${({ theme }) => theme.spacings.xl};
  }

  p:nth-of-type(2) {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: ${({ theme }) => theme.spacings.xxs};
  }

  form {
    & > div {
      margin-bottom: ${({ theme }) => theme.spacings.m};
    }

    & > div:last-of-type {
      margin-bottom: ${({ theme }) => theme.spacings.xl};
    }

    label {
      margin-bottom: ${({ theme }) => theme.spacings.xxs};
    }
  }
`;
//# sourceMappingURL=RegistrationSetpOne.js.map